import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.graphics.createMesh
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.math.asRadians
import com.github.chosamuel.matterjs.body.Body
import com.github.chosamuel.matterjs.collision.Pair
import com.github.chosamuel.matterjs.collision.Pairs
import com.github.chosamuel.matterjs.core.Matter
import com.github.chosamuel.matterjs.geometry.Vector
import com.github.chosamuel.matterjs.jsObject
import org.khronos.webgl.WebGLRenderingContext as GL
import kotlin.math.*

fun mVec(v: Vector): Vector2 = Vector2(v.x,v.y)

fun Application.mRect(rect: Rect) = mRect(
    mVec(rect.body.position),
    rect.width,
    rect.height,
    rect.body.angle
)



fun Application.mRect(center: Vector2, w: Double, h: Double, a: Double){
    val r = sqrt(w*w + h*h) * 0.5
    val offsetTheta = a + (PI*0.5)
    val theta = acos((h*0.5)/r)
    //top left
    val v1 = Vector2(cos(theta+PI+offsetTheta), sin(theta+PI+offsetTheta))
        .times(r)
        .plus(center)
    //top right
    val v2 = Vector2(cos(-theta+offsetTheta),sin(-theta+offsetTheta))
        .times(r)
        .plus(center)
    //bottom left
    val v3 = Vector2(cos(-theta+PI+offsetTheta),sin(-theta+PI+offsetTheta))
        .times(r)
        .plus(center)
    //bottom right
    val v4 = Vector2(cos(theta+offsetTheta),sin(theta+offsetTheta))
        .times(r)
        .plus(center)

    val m = createMesh()
    m.addVertex(v1)
    m.addVertex(v2)
    m.addVertex(v3)
    m.addVertex(v4)
    m.addColor(Color(0.0,0.0,0.0))
    m.addColor(Color(1.0,0.0,0.0))
    m.addColor(Color(0.0,1.0,0.0))
    m.addColor(Color(1.0,1.0,0.0))

    m.addIndex(0)
    m.addIndex(1)
    m.addIndex(2)
    m.addIndex(1)
    m.addIndex(3)
    m.addIndex(2)
    m.draw(GL.TRIANGLES)
}

class Rect(
    val center: Vector2,
    val width: Double,
    val height: Double,
    val options: dynamic = jsObject {}
){

    val body = Matter.Bodies.rectangle(
        center.x,
        center.y,
        width,
        height,
        options
    )
}

/**
 * Takes MatterJS's collision event pairs
 * and parse the ID to return a list of integers
 */
fun pairsToInts(pairs: Array<Pair>): List<Int>{
    val id = mutableListOf<Int>()
    pairs.map { p-> p.id }
        .forEach {
            id.add(it[1].toString().toInt())
            id.add(it[3].toString().toInt())
        }
    return id
}
